/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, OnInit, OnDestroy} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {Report} from '../../../../../model';

@Component({
  selector: 'confirm-delete-modal',
  templateUrl: './confirm-delete-report.modal.html',
  styleUrls: ['./confirm-delete-report.modal.scss']
})
export class ConfirmDeleteReportModal implements OnInit, OnDestroy {
  subject: Subject<boolean>;
  subscription: any;
  report: Report;
  deleteName: string = '';

  reports: Report[];

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if(reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if(this.subscription)
      this.subscription.unsubscribe();
  }

  onConfirm(): void {
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }
}
